/* esm.sh - react-dom@18.3.1 */
export * from "/*react-dom@18.3.1/esnext/react-dom.mjs";
export { default } from "/*react-dom@18.3.1/esnext/react-dom.mjs";
